import { render, staticRenderFns } from "./downLoadList.vue?vue&type=template&id=58847f30&scoped=true&"
import script from "./downLoadList.vue?vue&type=script&lang=js&"
export * from "./downLoadList.vue?vue&type=script&lang=js&"
import style0 from "./downLoadList.vue?vue&type=style&index=0&id=58847f30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58847f30",
  null
  
)

export default component.exports